import React from 'react';
import { useLocation } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';
import { parse } from 'qs';
import { RedirectWithStatusCode } from '../../components/RedirectWithStatusCode';
import { Authentication } from '../../components/Authentication';
import { PageMeta } from '../../components/PageMeta';
import { useUser } from '../../hooks/useUser';
import { isExternalUrl } from '../../lib/isExternalUrl';
import './RegisterPage.scss';

export const RegisterPage: React.FC = () => {
  const {
    user: { isLoggedIn, accessToken }
  } = useUser();
  const location = useLocation();
  const queryParams = parse(location.search, { ignoreQueryPrefix: true });
  const redirectTo = queryParams?.redirect_to || queryParams?.redirectTo || '/account';
  let redirectLink = !isExternalUrl(redirectTo.toString()) ? redirectTo : '/';

  // OIDC Flow: If redirecting to OAuth authorize endpoint, prepend /user-api and append access token
  if (isLoggedIn && typeof redirectLink === 'string' && redirectLink.startsWith('/oauth/')) {
    redirectLink = `/user-api${redirectLink}`;
    const separator = redirectLink.includes('?') ? '&' : '?';
    redirectLink = `${redirectLink}${separator}access_token=${accessToken}`;
  }

  if (isLoggedIn) {
    return (
      <RedirectWithStatusCode
        statusCode={StatusCodes.MOVED_TEMPORARILY}
        to={redirectLink as string}
      />
    );
  }

  return (
    <>
      <PageMeta
        title="Sign In"
        description="The runway, your way: sign in to your account for a faster checkout, to track your orders, and to add favorites to your Wish List."
      />
      <div className="RegisterPage">
        <Authentication fullPage />
      </div>
    </>
  );
};
